<script setup lang="ts">
/**
 * SchoolPromoVideo Component
 *
 * Displays the school promotional video in a dedicated section.
 * Only rendered when position is "section" and a video URL exists.
 */

interface Props {
  videoUrl: string
}

defineProps<Props>()

const { elementRef: sectionRef, isVisible } = useScrollReveal()
</script>

<template>
  <section
    ref="sectionRef"
    class="py-section-py bg-background text-foreground relative overflow-hidden transition-colors duration-300"
  >
    <div class="container mx-auto px-container-px relative z-10">
      <div
        class="mb-12 transition-all duration-1000 mx-auto text-center"
        :class="isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'"
      >
        <UiSectionHeader
          titlePrefix="Découvrez"
          titleHighlight="OXO"
          subtitle="Une école où la passion du jeu vidéo se vit au quotidien."
        />
      </div>

      <div
        class="max-w-5xl mx-auto transition-all duration-1000 delay-300"
        :class="isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'"
      >
        <UiVideoPlayer
          :src="videoUrl"
          :controls="true"
        />
      </div>
    </div>
  </section>
</template>
